export const getDateWithTimezone = ({ year = 0, month = 0, date = 0 }) => {
  const timeZone = new Date(year, month, date).getTimezoneOffset() / -60;
  return new Date(year, month, date, timeZone);
};
